import apiClient from "../config/api";

/**
 * Admin login service
 * @param {Object} credentials - Login credentials
 * @param {string} credentials.email - Admin email
 * @param {string} credentials.password - Admin password
 * @returns {Promise} API response with token and user data
 */
export const adminLogin = async (credentials) => {
  console.log("adminLogin called with:", { email: credentials.email, password: "***" });
  try {
    console.log("Making API call to /admin-login...");
    const response = await apiClient.post("/admin-login", credentials);
    console.log("API response received:", response);
    return response.data;
  } catch (error) {
    console.error("adminLogin error:", error);
    console.error("Error config:", error?.config);
    throw error;
  }
};

/**
 * Logout service - clears local storage
 */
export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
};

/**
 * Get stored auth token
 * @returns {string|null} Auth token
 */
export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

/**
 * Get stored user data
 * @returns {Object|null} User data
 */
export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

/**
 * Set auth token and user data
 * @param {string} token - Auth token
 * @param {Object} user - User data
 */
export const setAuthData = (token, user) => {
  localStorage.setItem("authToken", token);
  localStorage.setItem("user", JSON.stringify(user));
};

/**
 * Check if user is authenticated
 * @returns {boolean} Authentication status
 */
export const isAuthenticated = () => {
  return !!getAuthToken();
};

/**
 * Update admin profile (multipart/form-data)
 * @param {FormData} formData - Form data with email, firstName, lastName, and optionally profilePicture (File)
 * @returns {Promise} API response
 */
export const updateAdminProfile = async (formData) => {
  try {
    const response = await apiClient.put("/admin/profile", formData);
    return response.data;
  } catch (error) {
    console.error("updateAdminProfile error:", error);
    throw error;
  }
};

/**
 * Update admin password
 * @param {Object} payload - Password data
 * @param {string} payload.oldPassword - Current password
 * @param {string} payload.newPassword - New password
 * @param {string} payload.confirmPassword - Confirm new password
 * @returns {Promise} API response
 */
export const updateAdminPassword = async (payload) => {
  try {
    const response = await apiClient.put("/admin/password", payload);
    return response.data;
  } catch (error) {
    console.error("updateAdminPassword error:", error);
    throw error;
  }
};

